// extracted by mini-css-extract-plugin
export default {"location_wrapper":"styles_location_wrapper__qdCGC","time_left":"styles_time_left__ajDAQ"};